import { defineComponent } from "vue";
import useRoomMoreHooks from "./useRoomMoreHooks.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import copyIcon from "../common/icons/CopyIcon.vue.mjs";
import "../../directives/vTap.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "indexH5",
  emits: ["on-close-contact"],
  setup(__props, { emit }) {
    const { t, onCopy, contactContentList } = useRoomMoreHooks();
    function handleCloseContact() {
      emit("on-close-contact");
    }
    return { __sfc: true, t, onCopy, contactContentList, emit, handleCloseContact, SvgIcon, CopyIcon: copyIcon };
  }
});
export {
  _sfc_main as default
};
